import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface mediaCarousel {
  type: 'image' | 'pdf' | 'video',
  url: string
}

@Component({
  selector: 'app-carousel-overlay',
  templateUrl: './carousel-overlay.component.html',
  styleUrls: ['./carousel-overlay.component.css']
})
export class CarouselOverlayComponent implements OnInit {
  @Input() imageList = [];
  @Output() onClose = new EventEmitter();
  @Input() mediaList: mediaCarousel[] = [];
  @Input() selectedFrame = 0;
  @Input() autoplay = true;
  @Input() carouselType : 'imagesOnly' | 'multimedia' = 'imagesOnly';

  constructor() { }

  ngOnInit(): void {
  }

  closeOverlay(): void {
    this.onClose.emit();
  }

}
